// import React, { useState } from "react";
// import styles from "./styles2.module.css";
// import star from "../../images/star.svg";
// import op from "../../images/line.svg";
// import Button from "@mui/material/Button";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import axios from "axios";
// import EditModal from "../Modals/EditModal";
// import { API } from "../../backend";
// import { getAllCategoriesUnderParent } from "../../helper/categoryApiCalls/category";
// import { useEffect } from "react";

// const Playlist2 = ({ menu, setMenu, playlist, setList, list }) => {
//   const [success, setSuccess] = useState(null);
//   const [Eopen, setEopen] = useState(false);

//   console.log(success);
//   const handleVideo = () => {
//     setMenu("list");
//     setList(playlist);
//   };
//   // console.log("playlist", playlist);
//   // useEffect(() => {
//   //   setVideo(playlist.videos);
//   // }, [videos]);

//   // console.log("videos", videos);
//   const [initialBranchArray, setInitialBranchArray] = useState([]);
//   const [intialBranchCategory, setIntialBranchCategory] = useState([]);

//   async function getAllCategoriesUnderParentMain() {
//     let newOtherBranch = [...intialBranchCategory];
//     var initial = 0;
//     let newArray = await playlist;
//     for (const item of newArray?.category) {
//       await initialBranchArray.push(item._id);

//       let res = await getAllCategoriesUnderParent(item._id);

//       if (res.success === true) {
//         if (res.data.length > 0) {
//           let object = {
//             index: initial,
//             subCategories: res.data,
//           };

//           initial++;

//           await newOtherBranch.push(object);
//           await setIntialBranchCategory(newOtherBranch);
//         }
//       }
//     }
//   }

//   useEffect(() => {
//     if (playlist && playlist.category.length > 0) {
//       getAllCategoriesUnderParentMain();
//     }
//   }, []);

//   const [anchorEl, setAnchorEl] = React.useState(null);
//   const open = Boolean(anchorEl);
//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };
//   const handleDelete = () => {
//     const config = {
//       method: "delete",
//       url: `${API}/playlist/delete/${playlist._id}`,
//       headers: {
//         Authorization: `Bearer ${JSON.parse(
//           localStorage.getItem("_access_token")
//         )}`,
//         "Content-Type": "application/json",
//       },
//     };

//     axios(config)
//       .then((response) => {
//         console.log(response);
//         setSuccess(true);
//         window.location.reload();
//       })
//       .catch((error) => {
//         console.log(error);
//         setSuccess(false);
//       });
//     setAnchorEl(null);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const width = window.innerWidth;
//   return (
//     <div>
//       <div className={styles.play} key={playlist._id}>
//         <div className={styles.img}>
//           <img src={playlist?.videos[0]?.thumbnail} alt="%" />
//         </div>
//         <div className={styles.text} onClick={handleVideo}>
//           <div className={styles.text1}>
//             <span>{playlist?.name}</span>
//           </div>
//           <div className={styles.text2}>
//             <span>
//               {width > 768 && playlist?.description}
//               {width <= 768 && playlist?.description.substring(0, 13) + "....."}
//             </span>
//           </div>
//           <div className={styles.text3}>
//             <span>{playlist?.category[0].name}</span>
//           </div>
//           <div className={styles.text4}>
//             <div className={styles.some1}>
//               <span>
//                 {isNaN(Number(playlist.avgRating).toFixed(1))
//                   ? 0
//                   : Number(playlist.avgRating).toFixed(1)}
//               </span>
//             </div>
//             <div className={styles.some2}>
//               <img src={star} alt="*" />
//             </div>
//           </div>
//         </div>
//         <div className={styles.op}>
//           <Button
//             id="demo-positioned-button"
//             aria-controls={open ? "demo-positioned-menu" : undefined}
//             aria-haspopup="true"
//             aria-expanded={open ? "true" : undefined}
//             onClick={handleClick}
//           >
//             <img src={op} alt="*" />
//           </Button>
//         </div>
//         <Menu
//           id="demo-positioned-menu"
//           aria-labelledby="demo-positioned-button"
//           anchorEl={anchorEl}
//           open={open}
//           onClose={handleClose}
//           anchorOrigin={{
//             vertical: "top",
//             horizontal: "left",
//           }}
//           transformOrigin={{
//             vertical: "top",
//             horizontal: "left",
//           }}
//         >
//           <MenuItem onClick={() => setEopen((val) => !val)}>Edit</MenuItem>
//           <MenuItem onClick={handleDelete}>Delete</MenuItem>
//         </Menu>
//       </div>
//       {Eopen && (
//         <EditModal
//           open={Eopen}
//           setOpen={setEopen}
//           playlist={playlist}
//           intialBranchCategory={intialBranchCategory}
//           initialBranchArray={initialBranchArray}
//         />
//       )}
//     </div>
//   );
// };
// export default Playlist2;




// ========================================



import React, { useState, useEffect } from "react";
import styles from "./styles2.module.css";
import star from "../../images/star.svg";
import op from "../../images/line.svg";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import EditModal from "../Modals/EditModal";
import { API } from "../../backend";
import { getAllCategoriesUnderParent } from "../../helper/categoryApiCalls/category";

const Playlist2 = ({ menu, setMenu, playlist, setList, list }) => {
  const [success, setSuccess] = useState(null);
  const [Eopen, setEopen] = useState(false);

  const handleVideo = () => {
    setMenu("list");
    setList(playlist);
  };

  const [initialBranchArray, setInitialBranchArray] = useState([]);
  const [intialBranchCategory, setIntialBranchCategory] = useState([]);

  async function getAllCategoriesUnderParentMain() {
    let newOtherBranch = [];
    let initial = 0;

    for (const item of playlist?.category || []) {
      initialBranchArray.push(item?._id);

      let res = await getAllCategoriesUnderParent(item?._id);

      if (res?.success && res?.data?.length > 0) {
        newOtherBranch.push({
          index: initial,
          subCategories: res.data,
        });
        initial++;
      }
    }

    setIntialBranchCategory(newOtherBranch);
  }

  useEffect(() => {
    if (playlist?.category?.length > 0) {
      getAllCategoriesUnderParentMain();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playlist]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDelete = () => {
    const config = {
      method: "delete",
      url: `${API}/playlist/delete/${playlist?._id}`,
      headers: {
        Authorization: `Bearer ${JSON.parse(
          localStorage.getItem("_access_token")
        )}`,
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then(() => {
        setSuccess(true);
        window.location.reload();
      })
      .catch(() => {
        setSuccess(false);
      });

    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const width = window.innerWidth;

  if (!playlist) return null;

  return (
    <div className="cursor-pointer">
      <div className={styles.play} key={playlist?._id}>
        <div className={styles.img}>
          <img
            src={playlist?.videos?.[0]?.thumbnail}
            alt="thumbnail"
          />
        </div>

        <div className={styles.text} onClick={handleVideo}>
          <div className={styles.text1}>
            <span>{playlist?.name}</span>
          </div>

          <div className={styles.text2}>
            <span>
              {width > 768
                ? playlist?.description
                : playlist?.description?.substring(0, 13) + "....."}
            </span>
          </div>

          <div className={styles.text3}>
            <span>{playlist?.category?.[0]?.name}</span>
          </div>

          <div className={styles.text4}>
            <div className={styles.some1}>
              <span>
                {isNaN(Number(playlist?.avgRating).toFixed(1))
                  ? 0
                  : Number(playlist?.avgRating).toFixed(1)}
              </span>
            </div>
            <div className={styles.some2}>
              <img src={star} alt="star" />
            </div>
          </div>
        </div>

        <div className={styles.op}>
          <Button
            aria-controls={open ? "playlist-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <img src={op} alt="options" />
          </Button>
        </div>

        <Menu
          id="playlist-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <MenuItem onClick={() => setEopen(true)}>Edit</MenuItem>
          <MenuItem onClick={handleDelete}>Delete</MenuItem>
        </Menu>
      </div>

      {Eopen && (
        <EditModal
          open={Eopen}
          setOpen={setEopen}
          playlist={playlist}
          intialBranchCategory={intialBranchCategory}
          initialBranchArray={initialBranchArray}
        />
      )}
    </div>
  );
};

export default Playlist2;
